import { useState } from 'react';
import { Botao } from '../componentes/Botao.js';
import { IconeSair } from '../componentes/Icones.js';
import { useSessao } from '../autenticacao/SessaoContexto.js';
import { iniciaisDoNome } from '../autenticacao/tipos.js';
import './BlocoUsuario.css';

/**
 * Identidade e saída, no canto direito do cabeçalho.
 *
 * Sair é uma chamada ao middleware: o cookie é HttpOnly e só o servidor pode
 * apagá-lo. Enquanto ela não volta, o botão fica desabilitado para não
 * disparar duas vezes.
 */
export function BlocoUsuario() {
  const { estado, encerrarSessao } = useSessao();
  const [saindo, definirSaindo] = useState(false);

  if (estado.situacao !== 'autenticado') {
    return null;
  }

  const { usuario } = estado.sessao;

  return (
    <div className="bloco-usuario">
      <span className="bloco-usuario__avatar" aria-hidden="true">
        {iniciaisDoNome(usuario.nome)}
      </span>
      <span className="bloco-usuario__texto">
        <span className="bloco-usuario__nome">{usuario.nome}</span>
        <span className="bloco-usuario__perfil">{usuario.perfil}</span>
      </span>
      <Botao
        variante="secundario"
        altura="media"
        disabled={saindo}
        onClick={() => {
          definirSaindo(true);
          void encerrarSessao().finally(() => {
            definirSaindo(false);
          });
        }}
      >
        <IconeSair tamanho={15} />
        Sair
      </Botao>
    </div>
  );
}
